import type { Persona } from "@/types/api/Persona"
import { getLanguageDisplayName } from "@/utils/persona/persona-normalization"

export function isBuiltInPersona(persona: Persona | null | undefined): boolean {
  if (!persona) {
    return false
  }
  return !persona.organization_id || persona.organization_id === ""
}

/**
 * Display label for a persona's language, resolving the code from the top-level
 * field or the metadata fallbacks and defaulting to English. Shared so the table
 * cell and the column sort order use the same value.
 */
export function resolvePersonaLanguage(persona: Persona): string {
  const metadata = persona.metadata as Record<string, unknown> | undefined
  const language =
    persona.language_code ||
    (metadata?.language_code as string | undefined) ||
    (metadata?.language as string | undefined)
  return language ? getLanguageDisplayName(language) : "English"
}
